module.exports = "/images/green-tick.svg?f0122f512d24d755dcfecd2fa049f997";